module.exports = __webpack_public_path__ + "static/img/陈双明A.f3a221ec.png";